import ListItem from "@material-ui/core/ListItem";
import {ListItemText} from "@material-ui/core";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";

const AddMachinesAction = (props: {organizationUnitId: number, organizationId: number, userId: string}) => {
    const navigate = useNavigate();
    const {t} = useTranslation();

    // Do not offer option if organization is Philips
    if (props.organizationId === 3528) return <></>;

    return <ListItem onClick={() => navigate(`/organization-units/${props.organizationUnitId}/members/${props.userId}/machines?organizationId=${props.organizationId}`)}>
            <ListItemText style={{cursor: 'pointer'}}>
                {t('Members.Actions.AddMachines.Title')}
            </ListItemText>
        </ListItem>
};

export default AddMachinesAction;
